import { useEffect, useState } from "react";
import { Bell, CalendarDays, CalendarX, Plus } from "lucide-react";
import AppointmentCard from "@/components/admin/AppointmentCard";
import NewAppointmentDialog from "@/components/admin/NewAppointmentDialog";
import { useAppointments } from "@/components/admin/useAppointments";

export default function AppointmentsPanel({ headers }) {
  const { items, services, load, update, remove, add, replace, reviewLink, resend } = useAppointments(headers);
  const [showNew, setShowNew] = useState(false);

  useEffect(() => {
    load();
  }, []);

  const pending = items?.filter((a) => a.status === "pendiente").length || 0;
  const cancelled = items?.filter((a) => a.cancelled_by === "clienta").length || 0;

  return (
    <section data-testid="admin-appointments-panel">
      <h1 className="font-display text-2xl sm:text-3xl font-semibold text-obsidian flex items-center gap-3 flex-wrap">
        Solicitudes de cita
        {pending > 0 && (
          <span data-testid="appointments-pending-badge" className="inline-flex items-center gap-1.5 rounded-full bg-gold text-white text-xs font-sans font-medium px-3 py-1">
            <Bell className="w-3.5 h-3.5" /> {pending} pendiente{pending > 1 ? "s" : ""}
          </span>
        )}
        {cancelled > 0 && (
          <span data-testid="appointments-cancelled-badge" className="inline-flex items-center gap-1.5 rounded-full bg-red-100 text-red-700 text-xs font-sans font-medium px-3 py-1">
            <CalendarX className="w-3.5 h-3.5" /> {cancelled} cancelada{cancelled > 1 ? "s" : ""} por clientas
          </span>
        )}
      </h1>
      <p className="text-sm text-taupe mt-1">
        Contacta a cada clienta por WhatsApp o teléfono y confírmale la cita. Al confirmar, la clienta recibe un email y un recordatorio automático el día anterior.
      </p>
      <button onClick={() => setShowNew(true)} data-testid="new-appointment-btn" className="mt-4 inline-flex items-center gap-2 rounded-xl bg-obsidian hover:bg-cocoa text-white text-sm font-medium px-5 py-2.5 transition-colors">
        <Plus className="w-4 h-4" /> Nueva cita para una clienta
      </button>
      <NewAppointmentDialog open={showNew} onClose={() => setShowNew(false)} onCreated={(a) => { add(a); load(); }} headers={headers} />

      {items === null ? (
        <div className="grid gap-4 mt-6">
          {[...Array(2)].map((_, i) => <div key={i} className="h-32 rounded-2xl bg-sand/50 animate-pulse" />)}
        </div>
      ) : items.length === 0 ? (
        <div data-testid="appointments-empty" className="mt-6 rounded-2xl border border-dashed border-sand bg-creamcard p-10 text-center text-taupe">
          <CalendarDays className="w-9 h-9 mx-auto mb-3 text-sand" />
          <p className="font-display text-xl">Aún no hay citas solicitadas</p>
          <p className="text-sm mt-1">Cuando una clienta reserve desde la web, aparecerá aquí.</p>
        </div>
      ) : (
        <div className="grid gap-4 mt-6">
          {items.map((a) => <AppointmentCard key={a.id} a={a} services={services} onUpdate={update} onDelete={remove} onEdited={(u) => { replace(u); load(); }} headers={headers} reviewLink={reviewLink} onResend={resend} />)}
        </div>
      )}
    </section>
  );
}
